import React from "react";
import {
  Box,
  Grid,
  Typography,
  Divider,
  TextField,
  MenuItem,
  Button
} from "@mui/material";

const AddViolationForm = ({
  formData,
  setFormData,
  handleInputChange,
  handleFileChange,
  handleSubmit,
  previewImage,
  violationTypes
}) => {
  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ marginTop: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", marginBottom: 2 }}>
        Add New Violation
      </Typography>
      <Divider sx={{ marginY: 2 }} />

      <Grid container spacing={2}>
        {/* Violation Type */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            select
            label="Violation Type"
            name="ccr_violation_type_id"
            value={formData.ccr_violation_type_id}
            onChange={handleInputChange}
          >
            {violationTypes.map((type) => (
              <MenuItem key={type.id} value={type.id}>
                {type.title}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        {/* Violation Date */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            type="datetime-local"
            label="Violation Date"
            name="violated_at"
            value={formData.violated_at}
            onChange={handleInputChange}
            InputLabelProps={{ shrink: true }}
            sx={{ marginBottom: 2 }}
          />
        </Grid>

        {/* Comment */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Comment"
            name="comment"
            value={formData.comment}
            onChange={handleInputChange}
          />
        </Grid>

        {/* Upload Photo */}
        <Grid item xs={12} sm={6}>
          <Button variant="contained" component="label" fullWidth>
            Upload Photo
            <input type="file" hidden onChange={handleFileChange} />
          </Button>
          {previewImage && (
            <img
              src={previewImage}
              alt="Preview"
              style={{ width: "100px", height: "100px", marginTop: "10px" }}
            />
          )}
        </Grid>

        {/* Submit Button */}
        <Grid item xs={12} sm={6}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            Submit
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddViolationForm;
